import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getInsuranceData = createAsyncThunk("insurance/getInsuranceData", async ({ token, url }) => {
    console.log("Token", token, url)
    try {
        const response = await nodeinstance.get(url, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
});

const InsuranceDataSlice = createSlice({
    name: "insurance",
    initialState: {
        data: null,
        error: null,
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInsuranceData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getInsuranceData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getInsuranceData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getInsuranceData };
export default InsuranceDataSlice.reducer;
